import { MessageSquare, Phone, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const aiPhoneCallsForAppointmentRemindersAr: TemplateAr = {
  name: 'مكالمات هاتفية بالذكاء الاصطناعي لتذكير المواعيد',
  description:
    'مكالمات آلية بالذكاء الاصطناعي تذكّر العملاء بمواعيدهم القادمة، وتقلّل الغياب والإلغاء.',
  category: 'المكالمات الهاتفية بالذكاء الاصطناعي',
  workflow: [
    { icon: MessageSquare, label: 'موعد' },
    { icon: Sparkles, label: 'الـ AI يجدول' },
    { icon: Phone, label: 'مكالمة تذكير', final: true },
  ],
  detailDescription: {
    paragraph1:
      'ذكّر عميلك بموعده بدون ما تشيل الهاتف. الـ AI يتصل في التوقيت الأنسب قبل الموعد، ويؤكد الحضور، ويعرض إعادة الجدولة إذا احتاجها العميل. والمحادثة طبيعية، ومخصصة بتفاصيل الموعد واسم العميل والموقع.',
    paragraph2:
      'نتائج المكالمات والتأكيدات توصل لنظام التقويم أو الـ CRM أو برنامج الجدولة عندك. ومعدلات الغياب تنزل عادةً ٦٠-٨٠٪ مع التذكير الآلي. والـ AI يتولّى التأكيد والإلغاء وطلبات إعادة الجدولة، بلا تدخل بشري.',
  },
  benefits: [
    'الغياب عن المواعيد ينزل ٦٠-٨٠٪',
    'فريقك يوفّر وقته من مكالمات التذكير اليدوية',
    'الـ AI يأكد المواعيد تلقائياً ٢٤/٧',
    'طلبات إعادة الجدولة تنحل فوراً',
    'معدلات الحضور للمواعيد ترتفع',
    'يشتغل في القطاع الصحي والصالونات وقطاع الخدمات',
  ],
};
